/**
 * StructuredData — JSON-LD for WebNova + the two real projects.
 *
 * Honesty rule: we only describe things we can point to publicly. No
 * fabricated address, no invented aggregate ratings, no made-up employee
 * counts. Telephone and streetAddress are intentionally omitted; adding
 * them without verification would be the same mistake as the old fake
 * stats we already removed.
 *
 * References:
 *   - https://schema.org/ProfessionalService
 *   - https://schema.org/CreativeWork
 *   - https://developers.google.com/search/docs/appearance/structured-data
 *
 * The markup is rendered via a single <script type="application/ld+json">
 * tag (inline JSON, not injected after hydration) so crawlers see it in
 * the initial HTML payload.
 */

const WEBNOVA_URL = 'https://webnovaco.com';

const JSON_LD = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'ProfessionalService',
      '@id': `${WEBNOVA_URL}#studio`,
      name: 'WebNova Studio',
      url: WEBNOVA_URL,
      description:
        'A small Northern Virginia studio that rebuilds small-business websites. Hand-coded, fast, accessible, and tracker-free — no templates and no outsourcing.',
      email: 'hello@webnovaco.com',
      // areaServed structured for local SEO. The first entry anchors
      // the geographic intent ("Northern Virginia web design"); the
      // others widen reach without diluting the local ranking signal.
      areaServed: [
        { '@type': 'Place', name: 'Northern Virginia' },
        { '@type': 'Place', name: 'Washington D.C. metropolitan area' },
        { '@type': 'Place', name: 'United States' },
      ],
      priceRange: '$$',
      serviceType: 'Website design and development',
      knowsAbout: [
        'Web design',
        'Web performance',
        'Accessibility',
        'Information architecture',
        'Front-end development',
      ],
    },
    {
      '@type': 'CreativeWork',
      '@id': `${WEBNOVA_URL}#work-chefzeitoun`,
      name: 'Chef Zeitoun — website redesign',
      creator: { '@id': `${WEBNOVA_URL}#studio` },
      about: 'Restaurant website for a Levantine kitchen, with menu and reservation flows.',
      url: 'https://chefzeitoun.com',
      keywords: ['restaurant', 'menu design', 'reservations'],
    },
    {
      '@type': 'CreativeWork',
      '@id': `${WEBNOVA_URL}#work-vienna`,
      name: 'Vienna Aquarium & Pets — website redesign',
      creator: { '@id': `${WEBNOVA_URL}#studio` },
      about:
        'Information architecture and mobile-first rebuild for a twenty-year-old neighborhood pet store.',
      url: 'https://viennaaquariumandpets.com',
      keywords: ['retail', 'information architecture', 'mobile-first'],
    },
  ],
};

export default function StructuredData() {
  return (
    <script
      type="application/ld+json"
      // JSON.stringify is safe here: the values above are hard-coded, no user input.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(JSON_LD) }}
    />
  );
}
